import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiService } from 'src/app/Services/api.service';

@Component({
    selector: 'app-parkchirpconfig',
    templateUrl: './parkchirpconfig.component.html',
    styleUrls: ['./parkchirpconfig.component.scss'],
    standalone: false
})
export class ParkChirpConfigComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;

  public StandardPermitTypeName: string | null = null;
  public ReservationPermitTypeName: string | null = null;
  public ParkingLots: any[] = [];

  // NEW: resolved initial state names
  public StandardInitialStateName: string | null = null;
  public ReservationInitialStateName: string | null = null;

  constructor(private apiService: ApiService, private parentRoute: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
    this.apiService.Get<any>("integrations/parkchirp/configurations/" + this.ModelId).then(result => {
      this.Model = result;
      this.loadPermitTypeNames();
      this.loadInitialStateNames();
      this.StopLoading();
    });
  }

  private loadPermitTypeNames(): void {
    const stdId = this.Model?.StandardParkingPermitTypeId;
    const resId = this.Model?.ReservationParkingPermitTypeId;

    if (stdId) {
      this.apiService.Get<any>(`permits/standardpermittypes/${stdId}`).then(x => {
        this.StandardPermitTypeName = x?.Name || null;
      });
    }
    if (resId) {
      this.apiService.Get<any>(`permits/reservationpermittypes/${resId}`).then(x => {
        this.ReservationPermitTypeName = x?.Name || null;
      });
    }
  }

  // NEW: resolve names from workflow/default/{targetType}
  private async loadInitialStateNames(): Promise<void> {
    const stdId = this.Model?.StandardParkingPermitTypeId;
    const resId = this.Model?.ReservationParkingPermitTypeId;

    if (stdId && this.Model?.StandardInitialPermitState != null) {
      const className = await this.resolvePermitTypeClass('standard', stdId);
      const wf = await this.apiService.Get<any>(`workflow/default/${encodeURIComponent(className)}`);
      const state = (wf?.States || []).find((s: any) => s.Id === this.Model.StandardInitialPermitState);
      this.StandardInitialStateName = state?.Name || null;
    }

    if (resId && this.Model?.ReservationInitialPermitState != null) {
      const className = await this.resolvePermitTypeClass('reservation', resId);
      const wf = await this.apiService.Get<any>(`workflow/default/${encodeURIComponent(className)}`);
      const state = (wf?.States || []).find((s: any) => s.Id === this.Model.ReservationInitialPermitState);
      this.ReservationInitialStateName = state?.Name || null;
    }
  }

  private async resolvePermitTypeClass(kind: 'standard' | 'reservation', id: any): Promise<string> {
    try {
      const path = kind === 'standard' ? `permits/standardpermittypes/${id}` : `permits/reservationpermittypes/${id}`;
      const type = await this.apiService.Get<any>(path);
      return type?.ClassName || 'ParkingPermit';
    } catch {
      return 'ParkingPermit';
    }
  }

  
}
